import http from "./http-common"

/**
 * Service class for accessing the FTP server
 * @author KMU
 */
class FTPService {
    url = `/ftp/`;

    getPreviewUrl(filename: string): Promise<string> {
        return http.post(this.url + `previewFile`, filename, {responseType: 'blob'})
            .then(response => {
                return URL.createObjectURL(response.data);
            });
    }

    getFile(path: string) {
        return http.post(this.url + `getFile`,
            path, {responseType: 'blob'});
    }

    /**
     * @deprecated use getFile
     */
    getFiles(paths: Array<string>) {
        return http.post(this.url + `getFiles`,
            paths, {responseType: 'blob'});
    }

    uploadFile(file: File, dirName: string) {
        let formData = new FormData();
        formData.append("file", file);
        formData.append("dirName", dirName);
        return http.post(this.url + `uploadFiles`,
            formData, {
                headers: {
                    "Content-Type": 'multipart/form-data'
                }
            })
    }

    getMergedPDFFile(paths: Array<string>){
        return http.post(this.url + 'getMergedPDFFile', paths, {responseType: 'blob'});
    }

    getPageCount(paths: Array<string>){
        return http.post(this.url + 'getFilePositions', paths);
    }

}

export default new FTPService();